(ns common.schema.entities.survey.survey-question.schema
  (:require
    [common.data-types :as data-types]
    [common.schema.entities.survey.survey-question.options :as options]
    [common.schema.schema-utils :as su]))


(defn data-type-label
  "What a survey question's data type is called in the interface.

   Two of them need saying differently here than everywhere else. A question
   whose answer is chosen from a list is stored as a ref, and calling that
   \"Reference\" describes the storage rather than the question - the author is
   picking \"one of these options\", not a reference. The question creator had
   this mapping inline while the questions list printed the raw type, so the
   same question read \"Option - single\" in one place and \"Reference\" in the
   other."
  [tr data-type]
  (case data-type
    :data.type/ref-single (tr :single-option)
    :data.type/ref-multi  (tr :multi-option)
    (tr data-type)))

(def schema
  (concat
    (su/text-edn-field :survey-question/label-translations
                       "Label"
                       {:authorization            su/access-user-sug
                        :default-field-visibility :in-use-disabled})
    (su/calculated-field :survey-question/english-label
                         "ENG label"
                         {:default-field-visibility :in-use-disabled
                          :data-type                :data.type/text-simple
                          :calculation-triggers     {}
                          :calc-fn                  (fn [{:keys [entity-data]}]
                                                      (->> entity-data
                                                           :survey-question/label-translations
                                                           (data-types/parse-edn-string)
                                                           :ENG))})
    (su/keyword-field :survey-question/data-type
                      "Data type"
                      options/supported-data-types
                      {:authorization            su/access-user-sug
                       :default-field-visibility :in-use-disabled})
    (su/text-simple-field :survey-question/data-unit
                          "Data unit"
                          {:authorization            su/access-user-sug
                           :default-field-visibility :in-use-disabled})
    (su/text-edn-field :survey-question/info-translations
                       "Info"
                       {:authorization            su/access-user-sug
                        :default-field-visibility :in-use-disabled})
    (su/text-simple-field :survey-question/style
                          "Style"
                          {:authorization            su/access-user-sug
                           :default-field-visibility :in-use-disabled})
    (su/keyword-multi-field :survey-question/accepted-file-types
                            "Accepted file types"
                            options/file-type-options
                            {:authorization            su/access-user-sug
                             :default-field-visibility :in-use-disabled})
    (su/boolean-field :survey-question/multi-file?
                      "Multiple files?"
                      {:authorization            su/access-user-sug
                       :default-field-visibility :in-use-disabled})
    (su/text-simple-field :survey-question/file-name-abbreviation
                          "File name descriptor"
                          {:authorization            su/access-user-sug
                           :default-field-visibility :in-use-disabled})
    (su/text-simple-multi-field :survey-question/keywords
                                "Keywords"
                                {:authorization            su/access-user-user
                                 :default-field-visibility :in-use-disabled})
    (su/multi-ref-field :survey-question/options
                        "Option list"
                        [:entity.type/survey-question-option]
                        {:authorization            su/access-user-sug
                         :default-field-visibility :in-use-disabled})
    (su/single-ref-field :survey-question/kw-option-list
                         "Option list"
                         [:entity.type/kw-option-list]
                         {:authorization            su/access-user-sug
                          :default-field-visibility :in-use-disabled})
    (su/text-edn-field :survey-question/calculation-rules
                       "Calculation rules"
                       {:authorization            su/access-user-sug
                        :default-field-visibility :in-use-disabled})
    (su/keyword-field :survey-question/edn-data-type
                      "Complex data type"
                      options/supported-edn-templates
                      {:authorization            su/access-user-sug
                       :default-field-visibility :in-use-disabled})
    (su/multi-ref-field :survey-question/external-ids
                        "External IDs"
                        [:entity.type/survey-question-ext-id]
                        {:authorization            su/access-user-sug
                         :default-field-visibility :in-use-disabled})
    (su/boolean-field :survey-question/unique-identifier?
                      "Unique identifier?"
                      {:authorization            su/access-user-sug
                       :default-field-visibility :in-use-disabled})
    ))

(defn evaluate-config
  [config {:keys [question-lookup answer-lookup] :as ctx}]
  )
(defn mandatory?
  [{:keys [question question-lookup answer-lookup mandatory-field-config] :as ctx}]
  (and (coll? mandatory-field-config)
       (seq mandatory-field-config)
       (evaluate-config mandatory-field-config ctx)))

(defn hidden?
  [{:keys [question question-lookup answer-lookup conditional-field-config] :as ctx}]
  (and (coll? conditional-field-config)
       (seq conditional-field-config)
       (evaluate-config conditional-field-config ctx)))

(defn display-type
  [{:keys [question question-lookup answer-lookup] :as ctx}]
  (cond (hidden? ctx)
        :display.type/hidden
        (mandatory? ctx)
        :display.type/mandatory
        :else
        :display.type/normal))
